<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import { isEmpty, clone } from 'lodash'
  import api from '@/api'
  import SearchFilter from '../SearchFilter'
  import AppPagination from '@/components/ui/AppPagination'
  import UserPagination from '@/components/modules/user/UserPagination'
  import UserItem from '@/components/modules/user/UserItem'

  export default {
    name: 'UserOverview',
    components: {
      UserItem,
      UserPagination,
      AppPagination,
      SearchFilter,
    },
    metaInfo() {
      return {
        title: this.$t('meta.who-is-who.title'),
      }
    },
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
      type: String,
    },
    data() {
      return {
        page: 1,
        users: [],
        pagination: null,
        showFilter: false,
        search: '',
        queryFilters: {},
        filters: {},
      }
    },
    computed: {
      ...mapState('users', [
        'filterActive',
        'orderBy',
      ]),
      ...mapState('auth', ['settings']),
      results() {
        return this.options && this.options.results
      },
      getOrderBy() {
        return this.orderBy ?
          this.orderBy :
          this.settings && this.settings.base_options && this.settings.base_options.show_users_in_order
      },
      overviewOptions() {
        return this.options && this.options.options
      },
      showResetSearch() {
        return this.$route.query.query
      },
      setPayloadForGetUsers() {
        return { page: this.page, order_by: this.getOrderBy }
      },
      setPayloadForFilterAndSearchUsers() {
        return { page: this.page, query: this.search, order_by: this.getOrderBy }
      },
    },
    watch: {
      '$route.query'(value) {
        this.page = value.page || 1

        if (!isEmpty(value.query) && value.query.trim().length && !this.filterActive) {
          this.search = value.query.trim()

          this.searchUsers(this.setPayloadForFilterAndSearchUsers)
        } else if (this.filterActive) {
          this.filterUsers(this.setPayloadForFilterAndSearchUsers)
        } else {
          this.getUsers(this.setPayloadForGetUsers)
        }
      },
      overviewOptions: {
        handler(val) {
          if (val) {
            this.pagination = val.pagination
            this.filters = val.filters
          }
        },
        immediate: true,
      },
      results: {
        handler(val) {
          if (val) {
            this.users = val.users
          }
        },
        immediate: true,
      },
    },
    created() {
      if (this.$route.query.filters) {
        this.search = this.$route.query.query ? this.$route.query.query : ''
        this.queryFilters = this.filters
        this.showFilter = true
        this.setFiltersFromQuery(clone(this.filters)).then(_=>{
          this.filterUsers(this.setPayloadForFilterAndSearchUsers)
        })
      } else if (this.$route.query.page) {
        this.page = this.$route.query.page
        if (this.$route.query.query) {
          this.search = this.$route.query.query
          return this.searchUsers(this.setPayloadForFilterAndSearchUsers)
        }
        this.getUsers(this.setPayloadForGetUsers)
      } else if (this.$route.query.query) {
        this.search = this.$route.query.query
        this.searchUsers(this.setPayloadForFilterAndSearchUsers)
      } else {
        this.getUsers(this.setPayloadForGetUsers)
      }
    },
    destroyed() {
      this.clearUsers()
    },
    methods: {
      ...mapActions('users', [
        'getUsers',
        'searchUsers',
        'filterUsers',
        'clearUsers',
        'resetFilter',
        'setFilterActive',
        'setFiltersFromQuery',
      ]),
      onPaginate(page) {
        this.filterUserData(page).then(_ => {
          this.page = this.pagination.self
        })
      },
      async filterUserData(page) {
        await api.items
          .filterItems('users', {
            ...this.overviewOptions.filters,
            order_by: this.orderBy || this.overviewOptions.order_by,
            page,
            limit: this.overviewOptions.pagination.limit,
            query: this.$route.query.q,
          })
          .then(({ data }) => {
            this.users = data.results
            this.pagination = data.pagination
          })
      },
      clearSearch() {
        this.search = ''
        if (this.$route.query.query) {
          this.$router.push({ query: { page: 1 } })
        }
      },
      searchPersons(page = 1) {
        if (!isEmpty(this.search) && this.search.trim().length) {
          this.search = this.search.trim()
          if (
            (parseInt(this.$route.query.page) !== parseInt(page) && this.$route.query.query !== this.search) ||
            this.$route.query.query !== this.search ||
            parseInt(this.$route.query.page) !== parseInt(page)
          ) {
            this.$router.push({ query: { page, query: this.search } })
          } else {
            const payload = { page, query: this.search, order_by: this.getOrderBy }
            this.searchUsers(payload)
          }
        }
      },
      filterPersons(page = 1) {
        this.setFilterActive()
        if (
          (parseInt(this.$route.query.page) !== parseInt(page) && this.$route.query.query) ||
          parseInt(this.$route.query.page) !== parseInt(page)
        ) {
          this.$router.push({ query: { page } })
        } else if (
          this.pagination.last < this.pagination.self &&
          parseInt(this.$route.query.page) !== this.pagination.first
        ) {
          this.$router.push({ query: { page: this.pagination.first } })
        } else {
          const payload = { page, query: this.search, order_by: this.getOrderBy }
          this.filterUsers(payload)
        }
        if (this.$route.query && this.$route.query.filters !== this.filters) {
          this.search ? this.$router.replace({ query: { page, query: this.search, filters: this.filters } }) :
          this.$router.replace({ query: { page, filters: this.filters } })
        }
      },
      updateUsers(page = 1) {
        this.$router.replace({ query: { page } })
        this.queryFilters = {}
        const payload = { page: page, order_by: this.getOrderBy }
        this.getUsers(payload)
      },
    },
  }
</script>
